/**
 * ATTRIBUTION CÜMLESİ (CLOS-1124 / CLOS-1152) — TEK YARDIMCI, İKİ YÜZEY.
 *
 * Rapor 3 §19: bir öneri ya da karar "kim, kimin adına, hangi versiyonun hangi maddesinde"
 * sorularına TEK cümlede cevap verir: "SAN Otomotiv A.Ş. adına Ayşe Demir, v7 · Madde 8.2".
 * Sözleşme ekranı da aktivite akışı da bu fonksiyonu kullanır; iki yüzey iki farklı cümle
 * kuramaz.
 *
 * ⚠ Teknik kimlik YOK: kişi/kurum ADI gelir, uuid gelmez. Boş parça cümleden DÜŞER —
 * "null adına" ya da "v" gibi yarım çıktı üretilmez.
 */
export type AttributionInput = {
  /** İşlemi yapan kişinin görünen adı. */
  actorName: string;
  /** Adına hareket edilen taraf: temsil edilen sözleşme tarafı ya da öneren organizasyon. */
  onBehalfOf?: string | null;
  versionNumber?: number | null;
  /** Madde etiketi ("Madde 8.2" ya da madde başlığı) — görünen ad, kimlik değil. */
  clauseLabel?: string | null;
};

export function attributionLabel(input: AttributionInput): string {
  const kisi = input.actorName.trim();
  const adina = input.onBehalfOf?.trim();
  /** Kişisel alanda organizasyon adı kişinin adıysa "Ayşe adına Ayşe" yazılmaz. */
  const kim = adina && adina !== kisi ? `${adina} adına ${kisi}` : kisi;
  const yer: string[] = [];
  if (input.versionNumber !== null && input.versionNumber !== undefined) {
    yer.push(`v${input.versionNumber}`);
  }
  const madde = input.clauseLabel?.trim();
  if (madde) yer.push(madde);
  return yer.length > 0 ? `${kim}, ${yer.join(" · ")}` : kim;
}
